import React, { useMemo } from 'react';
import styled from 'styled-components';

interface Props {
  selected: number;
  total: number;
  onClick: (currentIndex: number) => void;
}

export const Thumbs: React.FC<Props> = ({ selected, total, onClick }) => {
  const dots = useMemo(() => {
    const result: React.ReactNode[] = [];
    for (let i = 0; i < total; ++i) {
      result.push(<Dot key={i} onClick={() => onClick(i)} selected={i === selected} />);
    }
    return result;
  }, [selected, total, onClick]);

  return <Styles>{dots}</Styles>;
};

const Styles = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  gap: 8px;
`;

const Dot = styled.div<{ selected: boolean }>(
  ({ selected, theme: { colors } }) => `
  background-color: ${selected ? colors.brand100 : colors.sidebarHeaderShadowColor};
  border-radius: 50%;
  height: 8px;
  width: 8px;
  cursor: pointer;
`,
);
